import Vue from 'vue'
import Router from 'vue-router'
const Login = () => import('@/components/Login')
const Home = () => import('@/components/Home')
const admin = () => import('@/components/admin/admin')
const loginbak = () => import('@/components/admin/Login_bak')
const welcome = () => import('@/components/admin/welcome')
const quotedPrice = () => import('@/components/quote/quotedPrice')
const carriage = () => import('@/components/quote/carriage')
const addorder = () => import('@/components/order/addorder')
const orderlist = () => import('@/components/order/orderlist')
const delivery = () => import('@/components/order/delivery')
const problems = () => import('@/components/order/problems')
const o_details = () => import('@/components/order/o_details')
const comadress = () => import('@/components/basic/comadress')
const importer = () => import('@/components/basic/importer')
const products = () => import('@/components/basic/products')
const checkAddress = () => import('@/components/basic/checkAddress')
const statement = () => import('@/components/basic/statement')
const transactions = () => import('@/components/basic/transactions')
const cmaker = () => import('@/components/order/cmaker')
const lastmaker = () => import('@/components/order/lastmaker')
const lastreceaccunt = () => import('@/components/order/lastreceaccunt')

const voucher = () => import('@/components/order/voucher')
const updatetrack = () => import('@/components/order/updatetrack')
const trackInfo = () => import('@/components/open/trackInfo')
const ticketIssueCollection = () => import('@/components/open/ticketIssueCollection')
const billOfLading = () => import('@/components/basic/billOfLading')
const cd_detail = () => import('@/components/order/cd_detail')
const zipcode = () => import('@/components/basic/zipcode')

//重复点的报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      hidden: true
    },{
      path: '/trackInfo',
      name: 'trackInfo',
      component: trackInfo,
      hidden: true,
    },{
      path: '/ticketIssueCollection/:status?/:code?',
      name: 'ticketIssueCollection',
      component: ticketIssueCollection,
      hidden: true,
    },
    {
      path: '/loginbak',
      name: 'loginbak',
      component: loginbak,
      meta:{requireAuth: true }
    },
    {
      path:'/',
        component:Home,
        name:'Home',
        children: [
           {
            path: 'admin',
            name: 'admin',
            component: admin,
            meta:{requireAuth: true,title:"首页" }
          },
          {
            path: '/trackInfos',
            name: 'trackInfo',
            component: trackInfo,
            meta:{requireAuth: true,title:"轨迹查询" }
          },{
            path: '/checkAddress',
            name: 'checkAddress',
            component: checkAddress,
            meta:{requireAuth: true,title:"地址查询" }
          },
          {
            path: 'welcome',
            name: 'welcome',
            component: welcome,
            meta:{requireAuth: true,title:"首页" }
          },{
            path: 'voucher',
            name: 'voucher',
            component: voucher,
            meta:{requireAuth: true,title:"附加费" }
          },{
            path: 'updatetrack',
            name: 'updatetrack',
            component: updatetrack,
            meta:{requireAuth: true,title:"换单记录" }
          },
          {
            path: 'cd_detail',
            name: 'cd_detail',
            component: cd_detail,
            meta:{requireAuth: true,title:"报关单" }
          },
          {
            path: 'billOfLading',
            name: 'billOfLading',
            component: billOfLading,
            meta:{requireAuth: true,title:"提单/CMR" }
          },

          {
            path: 'quotedPrice',
            name: 'quotedPrice',
            component: quotedPrice,
            meta:{requireAuth: true,title:"报价查询" }
          },{
            path: 'carriage',
            name: 'carriage',
            component: carriage,
            meta:{requireAuth: true,title:"运费查询" }
          },{
            path: 'addorder',
            name: 'addorder',
            component: addorder,
            meta:{requireAuth: true,title:"下单" }
          },{
            path: 'orderlist',
            name: 'orderlist',
            component: orderlist,
            meta:{requireAuth: true,title:"订单列表" }
          },
          {
            path: 'delivery',
            name: 'delivery',
            component: delivery,
            meta:{requireAuth: true,title:"提货单" }
          },
          {
            path: 'problems',
            name: 'problems',
            component: problems,
            meta:{requireAuth: true,title:"问题订单" }
          },{
            path: 'comadress',
            name: 'comadress',
            component: comadress,
            meta:{requireAuth: true,title:"地址库" }
          },{
            path: 'importer',
            name: 'importer',
            component: importer,
            meta:{requireAuth: true,title:"VAT信息" }
          },{
            path: 'o_details',
            name: 'o_details',
            component: o_details,
            meta:{requireAuth: true,title:"订单详情" }
          },{
            path: 'products',
            name: 'products',
            component: products,
            meta:{requireAuth: true,title:"产品库" }
          },{
            path: 'transactions',
            name: 'transactions',
            component: transactions,
            meta:{requireAuth: true,title:"款项往来" }
          },{
            path: 'statement',
            name: 'statement',
            component: statement,
            meta:{requireAuth: true,title:"对账单" }
          },{
            path: 'cmaker',
            name: 'cmaker',
            component: cmaker,
            meta:{requireAuth: true,title:"制单" }
          },{
            path: 'lastmaker',
            name: 'lastmaker',
            component: lastmaker,
            meta:{requireAuth: true,title:"尾程制单" }
          },{
            path: 'lastreceaccunt',
            name: 'lastreceaccunt',
            component: lastreceaccunt,
            meta:{requireAuth: true,title:"尾程账单" }
          },
          {
            path: 'zipcode',
            name: 'zipcode',
            component: zipcode,
            meta:{requireAuth: true,title:"偏远邮编" }
          }

        ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js